import { type ApiPath as SafeURL } from '@/services/apiPath';
import { API_ROUTES } from '@/api/apiRoutes';

export type RunScope = { kind: 'recipe'; recipeId: string } | { kind: 'tool'; toolId: string };

export interface RunEndpoints {
  run: SafeURL;
  cost: SafeURL;
  status: SafeURL; // caller appends ?runIds=...
  cancel: SafeURL;
  results: SafeURL;
  userData: SafeURL;
  saveUserData: SafeURL;
}

export const runEndpoints = (scope: RunScope): RunEndpoints => {
  if (scope.kind === 'tool') {
    const { toolId } = scope;
    return {
      run: API_ROUTES.tools.run({ toolId }),
      cost: API_ROUTES.tools.cost({ toolId }),
      status: API_ROUTES.tools.runsStatus({ toolId }),
      cancel: API_ROUTES.tools.runsCancel({ toolId }),
      results: API_ROUTES.tools.results({ toolId }),
      userData: API_ROUTES.tools.userData({ toolId }),
      saveUserData: API_ROUTES.tools.userData({ toolId }),
    };
  }
  const { recipeId } = scope;
  return {
    run: API_ROUTES.recipeRuns.run({ recipeId }),
    cost: API_ROUTES.recipeRuns.cost({ recipeId }),
    status: API_ROUTES.recipeRuns.status({ recipeId }),
    cancel: API_ROUTES.recipeRuns.cancel({ recipeId }),
    results: API_ROUTES.recipeRuns.designAppResults({ recipeId }),
    userData: API_ROUTES.recipes.userDesignApp({ recipeId }),
    saveUserData: API_ROUTES.recipes.designAppParamsSave({ recipeId }),
  };
};
